import { render, staticRenderFns } from "./NewEconomicGroup.vue?vue&type=template&id=64e0885d"
import script from "./NewEconomicGroup.vue?vue&type=script&lang=js"
export * from "./NewEconomicGroup.vue?vue&type=script&lang=js"
import style0 from "./NewEconomicGroup.vue?vue&type=style&index=0&id=64e0885d&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports